import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  ManyToOne,
  CreateDateColumn,
  UpdateDateColumn,
  JoinColumn,
} from 'typeorm';

import { FinancialsStatus } from '../../interface/financials/financials-response.interface';
import { UsersEntity } from '../users/user.entity';

@Entity('financials')
export class FinancialsEntity {
  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column({ type: 'decimal', precision: 15, scale: 2 })
  annual_sales_target!: number;

  @Column({ type: 'varchar' })
  status!: FinancialsStatus;

  @CreateDateColumn({ nullable: true })
  created_at?: Date | null;

  @UpdateDateColumn({ nullable: true })
  updated_at?: Date | null;

  // Relations: Created/Updated by Users
  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by' })
  created_by?: UsersEntity | null;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by' })
  updated_by?: UsersEntity | null;
}